/**
 * Saga that shows an alert and returns the alert result (i.e. which
 * button was clicked). It is also possible for the alert to have been ended
 * because of a global ABORT_CURRENT_TASKS action, in which case an
 * exception with type AbortCurrentTasks is thrown. FORCE_END_ALERTS is
 * dispatched when something needs to globally change the view for the app
 * - e.g. when a teacher switches tasks in a lesson. This exception must be
 * caught and handled by the caller somewhere in the saga hierarchy as
 * otherwise it will result in the root saga being cancelled, breaking the app
 * @param alertSpec
 * @returns {string}
 */
import { take, put, call, cancelled } from 'redux-saga/effects';
import { startAlert, END_ALERT, endAlert } from './actions';
import { abortCurrentTasksException } from 'phoenix2/exceptions';
import { ABORT_CURRENT_TASKS } from '../common/actions';

export function* showAlert(alertSpec) {
    let result;
    let wasCancelled = false;
    yield put(startAlert(alertSpec));
    try {
        const action = yield take([END_ALERT, ABORT_CURRENT_TASKS]);
        if (action.type === ABORT_CURRENT_TASKS) {
            wasCancelled = true;
        } else {
            result = action.result;
        }
    } finally {
        // If the Saga was cancelled (e.g. app reset), end the alert:
        if (yield cancelled()) {
            yield put(endAlert());
            wasCancelled = true;
        }
    }
    if (wasCancelled) {
        throw abortCurrentTasksException();
    }

    return result;
}

export function* showAlertAndCallback(alertSpec, callback) {
    const result = yield call(showAlert, alertSpec);
    return callback(result);
}
